import { Component, Input } from '@angular/core'

@Component({
  selector: 'dmmp-website-article-content',
  templateUrl: './website-article-content.component.html'
})
export class WebsiteArticleContentComponent {

  @Input() identifier
  @Input() data
  @Input() module

}
